import { useEffect, useState } from "react"

export default function useGetSegment() {
  const [segment, setSegment] = useState()
  const [isSomeSegment, setIsSomeSegment] = useState()
  const [someSegmentList, setSomeSegmentList] = useState()

  const calculateAge = () => {
    if (typeof window !== "undefined") {
      if (localStorage.getItem("USER_INFO") === null) {
        return 0
      } else {
        var today = new Date()
        var birthDate = new Date(
          JSON.parse(localStorage.getItem("USER_INFO")).birthdate
        )
        var age = today.getFullYear() - birthDate.getFullYear()
        var m = today.getMonth() - birthDate.getMonth()
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--
        }
        return age
      }
    } else {
      return 0
    }
  }

  const getAgeSegment = (age) => {
    if (age >= 9 && age <= 17) {
      return "Adolescente"
    } else if (age >= 18 && age <= 24) {
      return "Adulto Joven"
    } else if (age >= 25) {
      return "Adulto"
    } else {
      return "Anónimo"
    }
  }

  const handleSetSegment = () => {
    let age = calculateAge()
    let segment = getAgeSegment(age)
    setSegment(() => segment)
  }

  useEffect(() => {
    handleSetSegment()
    // eventListener localStorage UPDATE
    window.addEventListener("storage", handleSetSegment)
    return () => {
      window.removeEventListener("storage", handleSetSegment)
      setSegment(() => null)
    }
  }, [])

  useEffect(() => {
    if (someSegmentList) {
      let __isSome = someSegmentList.some((__segment) => __segment === segment)
      setIsSomeSegment(() => __isSome)
    }
    return () => {
      setIsSomeSegment(() => undefined)
    }
  }, [segment, someSegmentList])

  return [segment, setSomeSegmentList, isSomeSegment]
}
